/**
 * Items Accordion
 */
const accordion = () => {
  const $items = document.querySelectorAll('.p-itemsContent')

  const hash = location.hash

  if ($items.length && hash) {
    // alert(hash)
    const items = document.querySelector(hash)
    const toggleButton = items.querySelector('.js-toggleItem')
    const item = items.querySelector('.p-itemsContent__item')
    toggleButton.classList.add('is-show')
    item.classList.add('is-show')
  }
  // else {
  // }

  for (let i = 0; i < $items.length; i++) {
    const items = document.getElementsByClassName('p-itemsContent')[i]
    const toggleButton = items.querySelector('.js-toggleItem')
    const item = items.querySelector('.p-itemsContent__item')
    const closeButton = items.querySelector('.js-closeItem')

    toggleButton.addEventListener('click', (e) => {
      if (!toggleButton.classList.contains('is-show')) {
        for (let i = 0; i < $items.length; i++) {
          const items = document.getElementsByClassName('p-itemsContent')[i]
          const toggleButton = items.querySelector('.js-toggleItem')
          const item = items.querySelector('.p-itemsContent__item')

          toggleButton.classList.remove('is-show')
          item.classList.remove('is-show')
        }
      }
      toggleButton.classList.toggle('is-show')
      item.classList.toggle('is-show')
      // e.preventDefault()
    });

    closeButton.addEventListener('click', (e) => {
      toggleButton.classList.remove('is-show')
      item.classList.remove('is-show')
      // e.preventDefault()
    });
  }
}

export { accordion };
